import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import {router} from "./App"
import * as Sentry from "@sentry/react";
import ErrorBoundary from './components/ErrorBoundary';
// De vaste teksten van de widget. Stond hier niet, waardoor i18next nooit werd opgestart en
// elke t() de sleutel zelf teruggaf. (WI1)
import './i18n';
// De voorbeeldlink van een winkel in de testfase: het teken uit het adres lezen voordat er ook maar
// een aanvraag vertrekt, en ook de aanvragen die niet via axiosInstance gaan het laten meesturen.
// (Mollie blok 2, 15-09-2026.)
import axios from 'axios';
import { koppelAanAxios, startTestmodus } from './lib/testmodus';
// De instellingen op één plek. Vite kent process.env niet; daar heet het import.meta.env, en dat
// lezen gebeurt nu in dit ene bestand in plaats van op 21 plekken. (WI11)
import {
    apiAdres, omgeving, versie, sentryAdres,
    sentryMeetdeel, sentryOpnamedeel, sentryFoutopnamedeel, sentryLokaalMelden,
    instellingenNakijken,
} from './instellingen';
// De keuzes voor Sentry -- omgeving, wat er gemeten en opgenomen wordt -- als losse functies, zodat
// ze te toetsen zijn. (15-09-2026.)
import { sentryOpties } from './lib/sentryInstellingen';

instellingenNakijken();

startTestmodus();
koppelAanAxios(axios);

const apiUrl = apiAdres.trim().replace(/\/$/, '');

Sentry.init({
  ...sentryOpties({
    dsn: sentryAdres,
    hostnaam: window.location.hostname,
    bouwwaarde: omgeving,
    versie,
    meetdeel: sentryMeetdeel,
    opnamedeel: sentryOpnamedeel,
    foutopnamedeel: sentryFoutopnamedeel,
    lokaalMelden: sentryLokaalMelden,
  }),

  // Uit. Met deze schakelaar stuurt Sentry het ip-adres en alles wat hij aan de gast kan koppelen
  // mee. In een boekwidget is dat naam, e-mailadres en telefoonnummer van iemand die alleen een
  // tafel wilde reserveren. (WI7, besloten met Martijn 13-09-2026.)
  sendDefaultPii: false,

  integrations: [
    Sentry.browserTracingIntegration(),

    // De sessieopname speelt terug wat de gast op het scherm deed. Zonder afschermen zie je hem
    // letterlijk zijn naam, e-mailadres en telefoonnummer intypen -- daar heb je geen grondslag
    // voor. Met afschermen zie je nog steeds de vorm van het scherm, de klikken en het foutpad, en
    // in de praktijk is dat waar je een fout mee oplost.
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
      maskAllInputs: true,
    }),
  ],

  // Propagate Sentry trace headers to the Jimani API so back-end errors link to front-end traces
  tracePropagationTargets: [
    'localhost',
    ...(apiUrl ? [new RegExp(`^${apiUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`)] : []),
  ],
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <ErrorBoundary >
   <RouterProvider router={router} />
   </ErrorBoundary>
  // </React.StrictMode>
);
reportWebVitals();
